const CoreRouteConstants = {
  ADD_ALERT: '/alerts/add',
  EDIT_ALERT: (alertId: string) => `/alerts/edit/${alertId}`,
  ALERTS: '/alerts',
  ALERTS_ADMINISTRATION: '/alertsAdministration',
  AUTHORIZE: '/authorize',
  DASHBOARD: '/',
  LEGAL_DOCUMENTS: '/legal',
  LINK_AGENCY: (userKey: string) => `/linkagency/${userKey}`,
  LOGIN: '/login',
  SITE_ADMINISTRATION: '/siteAdministration',
  LEGAL_AGREEMENTS: '/legalAgreements',
  TERMS_AND_CONDITIONS: '/terms',
};

export default CoreRouteConstants;
